import axios, { AxiosInstance, InternalAxiosRequestConfig } from "axios";
import hmacHelper from "./HmacHelper.ts";
import { getExternalBaseUrl, EXTERNAL_CONFIG } from "./ExternalConfig.ts";

class MerchantExternalService {
  private readonly api: AxiosInstance;
  private readonly clientId = EXTERNAL_CONFIG.clientId;
  private readonly clientSecret = EXTERNAL_CONFIG.clientSecret;
  private readonly contextPath = EXTERNAL_CONFIG.services.merchant;
  private readonly dropContextPath = EXTERNAL_CONFIG.dropContextPath;

  constructor() {
    this.api = axios.create({
      baseURL: getExternalBaseUrl()
    });

    this.api.interceptors.request.use((config) => this.signRequest(config));
  }

  private signRequest(config: InternalAxiosRequestConfig) {
    console.log("Signing external request...");
    if (!config.url?.includes("/ext/")) return config;

    console.log("config url: ", config.url);
    console.log("config base url: ", config.baseURL);
    console.log("windows location: ", window.location.origin);

    const url = new URL(config.url!, config.baseURL).toString();

    console.log("External url: ", url.toString());

    const method = (config.method || "get").toUpperCase();
    const body = config.data || {};

    const hmacHeaders = hmacHelper.generateHmacHeaders(
      method,
      url,
      body,
      this.clientId,
      this.clientSecret,
      this.contextPath,
      this.dropContextPath
    );

    console.log("hmacHeaders: ", hmacHeaders);

    // Merge headers safely (AxiosHeaders now uses a class)
    Object.entries(hmacHeaders).forEach(([key, value]) => {
      config.headers.set?.(key, value);
    });

    return config;
  }

  public getMonitoringCenterLegalNames() {
    return this.api.get<Array<Record<number, string>>>(
      "/merchant-service/ext/merchants/monitoring-centers/legal-names"
    );
  }
}

export default new MerchantExternalService();
